import { removeCookie } from "../../cookies";
import { clearAvData } from "../../expiringAgeVerification";
import {
  PASS_VERIFIED_DATE_OF_BIRTH_COOKIE,
  PASS_VERIFIED_NAME,
  PASS_VERIFIED_PHONE_COOKIE,
} from "../../passVerificationData";

export const AGE_PROOF_LOCAL_NAME = "ageproof_local";

export const clearAvCookies = () => {
  removeCookie(AGE_PROOF_LOCAL_NAME);
  removeCookie(PASS_VERIFIED_DATE_OF_BIRTH_COOKIE);
  removeCookie(PASS_VERIFIED_PHONE_COOKIE);
  removeCookie(PASS_VERIFIED_NAME);
  clearAvData();
};
